import React, { useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  Row,
  Col,
  notification,
} from "antd";
import { TagOutlined } from "@ant-design/icons";
import { addRoleApi } from "../../../../api/role";
import { getAccessToken } from "../../../../api/auth";

import "./AddRoleForm.scss";

export default function AddRoleForm(props) {
  const { setIsVisibleModal, setReloadRoles } = props;

  const [inputs, setInputs] = useState({
    role_code: "",
    name: "",
    description: ""
  });

  /*
  const [formValid, setFormValid] = useState({
    phone: false
  });
  */

  /*
  const inputValidation = (e) => {
    const { type, name } = e.target;

    setInputs({
      ...inputs,
      [name]: e.target.value,
    });
  };
  */

  const isFormValid = (e) => {
    //console.log(inputs);
    let errorExists = false;
    if (!inputs.name) {
      notification["error"]({
        message: "Obligatorios: Nombre.",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addRole= async (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      const accessToken = getAccessToken();

      await addRoleApi(accessToken, inputs)
        .then((response) => {
          if (response === "ERR_CONNECTION_REFUSED" ||response === "Failed to fetch" ||response === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
          } else if (response.code !== 200) {
            notification["error"]({
              message: response.message,
            });
          }
          else {
            notification["success"]({
              message: "Rol creado",
            });
            setIsVisibleModal(false);
          }
          setReloadRoles(true);
        })
        .catch((err) => {
          notification["error"]({
            message: err,
          });
        });
    }
  };

  return (
    <div className="add-role-form">
      <AddForm
        inputs={inputs}
        setInputs={setInputs}
        //inputValidation={inputValidation}
        addRole={addRole}
      />
    </div>
  );
}

function AddForm(props) {
  const { inputs, setInputs, addRole } = props; //inputValidation

  return (
    <Form className="form-add" onSubmit={addRole}>
      <Row gutter={24}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={inputs.role_code}
              onChange={(e) =>
                setInputs({ ...inputs, role_code: e })
              }
              min={1}
              disabled={true}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label"><span className="control-required">*</span> Nombre</label>
          <Form.Item >
            <Input
              placeholder="Nombre"
              value={inputs.name}
              onChange={(e) =>
                setInputs({ ...inputs, name: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <label className="control-label">Descripción</label>
          <Form.Item>
            <Input
              //prefix={<EnvironmentOutlined />}
              placeholder="Descripción"
              name="description"
              value={inputs.description}
              onChange={(e) =>
                setInputs({ ...inputs, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addRole}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}
